import React from "react";
import { SmallPlainInsetBtnIcon } from "../../components/buttons/index";
import { StarIcon, LineThroughCircleIcon } from "../icons";

export default function GradeStateBtn({
  evt,
  end,
  hoursSinceEnd,
  setGradingEvent,
  pendingBAs = [],
  style = {},
}) {
  // disable until shift has ended, and after 48 hours
  const isDisabled = Date.now() < new Date(end).getTime() || hoursSinceEnd > 48;

  const handleClick = () => {
    setGradingEvent({
      scheduleId: evt.id,
      pendingBAs,
    });
  };

  return (
    <SmallPlainInsetBtnIcon
      onClick={handleClick}
      disabled={isDisabled}
      text="Grade"
      icon={isDisabled ? LineThroughCircleIcon : StarIcon}
      width="80px"
      style={style}
    />
  );
}